/* GW Judge.me Reviews — <gw-jm-reviews>
   Fetches real reviews from the Judge.me widget API and replaces the
   server-rendered skeleton. Everything the Figma card shows comes from the
   API payload; the icons are inlined here (not uploadable assets) because
   they repeat 20+ times per card set and need currentColor.

   API: GET api.judge.me/api/v1/widgets/all_reviews_page?json_request=true
   Verified CORS-clean from the storefront with the shop's PUBLIC token, which
   is designed to be embedded in client JS. Reviews are filtered to 5-star,
   product-scoped (not shop reviews) and picture-bearing, matching the frames.

   If the fetch fails or nothing qualifies, the section removes itself on the
   live site and shows the editor placeholder in the theme editor — the same
   split contract as the other gw- sections. */

const STAR = '<svg class="gw-jmr__star" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M9.55676 2.90917L11.1575 6.15228C11.2021 6.24252 11.2679 6.32058 11.3493 6.37972C11.4307 6.43887 11.5253 6.47733 11.6249 6.49179L15.2038 7.01193C15.3184 7.02858 15.4261 7.07698 15.5147 7.15165C15.6033 7.22632 15.6692 7.32429 15.7049 7.43447C15.7407 7.54465 15.7449 7.66265 15.7172 7.77511C15.6894 7.88756 15.6306 7.99 15.5477 8.07083L12.9575 10.5952C12.811 10.7379 12.7446 10.9434 12.7788 11.1445L13.3901 14.7091C13.4097 14.8232 13.3969 14.9406 13.3533 15.0479C13.3096 15.1551 13.2368 15.248 13.1431 15.3161C13.0495 15.3842 12.9386 15.4247 12.8231 15.433C12.7076 15.4413 12.592 15.4172 12.4895 15.3633L9.288 13.68C9.19887 13.6332 9.09972 13.6088 8.99907 13.6088C8.89842 13.6088 8.79927 13.6332 8.71014 13.68L5.50862 15.3633C5.40612 15.4172 5.29058 15.4413 5.17507 15.433C5.05956 15.4247 4.94869 15.3842 4.85499 15.3161C4.76129 15.248 4.6885 15.1551 4.64486 15.0479C4.60121 14.9406 4.58844 14.8232 4.608 14.7091L5.21938 11.1445C5.2364 11.0453 5.22902 10.9434 5.19788 10.8477C5.16673 10.752 5.11276 10.6654 5.04062 10.5952L2.45048 8.07083C2.36749 7.99 2.30878 7.88756 2.28099 7.77511C2.25319 7.66265 2.25742 7.54465 2.2932 7.43447C2.32898 7.32429 2.39488 7.22632 2.48345 7.15165C2.57201 7.07698 2.6797 7.02858 2.79435 7.01193L6.37324 6.49179C6.47283 6.47733 6.56742 6.43887 6.64884 6.37972C6.73026 6.32058 6.79608 6.24252 6.84062 6.15228L8.44138 2.90917C8.67104 2.448 9.32897 2.448 9.55676 2.90917Z" fill="#C8A96A"/></svg>';

const BADGE = '<svg class="gw-jmr__badge" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Verified buyer"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.18144 1.34328C9.20469 0.385572 10.7953 0.385572 11.8186 1.34328L12.7046 2.17258C12.9544 2.40632 13.2805 2.54141 13.6224 2.55272L14.8353 2.59285C16.2361 2.6392 17.3608 3.76394 17.4072 5.16469L17.4473 6.37766C17.4586 6.7195 17.5937 7.04562 17.8274 7.29537L18.6567 8.18144C19.6144 9.20469 19.6144 10.7953 18.6567 11.8186L17.8274 12.7046C17.5937 12.9544 17.4586 13.2805 17.4473 13.6224L17.4072 14.8353C17.3608 16.2361 16.2361 17.3608 14.8353 17.4072L13.6223 17.4473C13.2805 17.4586 12.9544 17.5937 12.7046 17.8274L11.8186 18.6567C10.7953 19.6144 9.20469 19.6144 8.18144 18.6567L7.29537 17.8274C7.04562 17.5937 6.7195 17.4586 6.37766 17.4473L5.16469 17.4072C3.76394 17.3608 2.6392 16.2361 2.59285 14.8353L2.55272 13.6224C2.54141 13.2805 2.40632 12.9544 2.17258 12.7046L1.34328 11.8186C0.385572 10.7953 0.385572 9.20469 1.34328 8.18144L2.17258 7.29537C2.40632 7.04562 2.54141 6.7195 2.55272 6.37766L2.59285 5.16469C2.6392 3.76394 3.76394 2.6392 5.16469 2.59285L6.37766 2.55272C6.7195 2.54141 7.04562 2.40632 7.29537 2.17258L8.18144 1.34328ZM13.8938 7.92712C14.1297 7.67516 14.1166 7.27963 13.8646 7.04375C13.6127 6.80784 13.2171 6.82087 12.9813 7.07287L8.75666 11.5855L7.01875 9.72912C6.78287 9.47712 6.38734 9.46409 6.13537 9.7C5.88337 9.93588 5.87034 10.3314 6.10625 10.5834L8.30037 12.9271C8.41856 13.0534 8.58375 13.125 8.75666 13.125C8.92956 13.125 9.09475 13.0534 9.21291 12.9271L13.8938 7.92712Z" fill="#897244"/></svg>';

const PAGE_SIZE = 50;
const MAX_PAGES = 4;

const esc = (s) =>
  String(s == null ? '' : s).replace(/[&<>"']/g, (c) =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])
  );

/* Judge.me body_html is merchant/customer text. Keep the handful of inline tags
   the design needs and drop everything else, including the trailing empty <p>
   Judge.me emits on some reviews (a lone zero-width space). */
const sanitizeBody = (html) => {
  const doc = new DOMParser().parseFromString(String(html || ''), 'text/html');
  const allowed = new Set(['P', 'BR', 'EM', 'STRONG', 'I', 'B']);
  const walk = (node) => {
    [...node.children].forEach((el) => {
      walk(el);
      if (!allowed.has(el.tagName)) el.replaceWith(...el.childNodes);
      else [...el.attributes].forEach((a) => el.removeAttribute(a.name));
    });
  };
  walk(doc.body);
  [...doc.body.querySelectorAll('p')].forEach((p) => {
    if (!p.textContent.replace(/[\s​]/g, '')) p.remove();
  });
  return doc.body.innerHTML;
};

const formatDate = (iso) => {
  const d = new Date(iso);
  if (Number.isNaN(d.valueOf())) return '';
  const p = (n) => String(n).padStart(2, '0');
  return `${p(d.getMonth() + 1)}/${p(d.getDate())}/${d.getFullYear()}`;
};

class GwJmReviews extends HTMLElement {
  connectedCallback() {
    this.token = this.dataset.token;
    this.shop = this.dataset.shop;
    this.limit = parseInt(this.dataset.limit, 10) || 12;
    this.designMode = this.dataset.designMode === 'true';
    this.track = this.querySelector('[data-gw-jmr-track]');
    if (!this.token || !this.shop || !this.track) return this.fail();
    this.load();
  }

  api(path, params) {
    const q = new URLSearchParams({
      api_token: this.token,
      shop_domain: this.shop,
      ...params,
    });
    return fetch(`https://api.judge.me/api/v1/widgets/${path}?${q}`, {
      headers: { Accept: 'application/json' },
    }).then((r) => {
      if (!r.ok) throw new Error(`Judge.me ${path} ${r.status}`);
      return r.json();
    });
  }

  async load() {
    try {
      const [reviews] = await Promise.all([this.collect(), this.headline()]);
      if (!reviews.length) return this.fail();
      this.render(reviews);
    } catch (e) {
      console.warn('[gw-judgeme-reviews]', e.message);
      this.fail();
    }
  }

  /* Page until `limit` qualifying reviews are found. The store's newest
     reviews are not all 5-star product reviews with pictures, so one page is
     not guaranteed to fill the track. */
  async collect() {
    const out = [];
    for (let page = 1; page <= MAX_PAGES && out.length < this.limit; page += 1) {
      const data = await this.api('all_reviews_page', {
        json_request: 'true',
        per_page: String(PAGE_SIZE),
        page: String(page),
      });
      const batch = (data.reviews || []).filter(
        (r) =>
          r.rating === 5 &&
          !r.is_shop_review &&
          r.product_pictures_url &&
          r.product_url &&
          (r.body || '').trim()
      );
      out.push(...batch);
      if (page >= (data.total_pages || 1)) break;
    }
    return out.slice(0, this.limit);
  }

  /* Live review count, floored to a 1,000 step: 1176 -> "1,000+". */
  async headline() {
    const el = this.querySelector('[data-gw-jmr-count]');
    if (!el) return;
    const { all_reviews_count: n } = await this.api('all_reviews_count', {});
    if (!n || n < 1000) return;
    const floored = Math.floor(n / 1000) * 1000;
    el.textContent = el.textContent.replace(
      /[\d,]+\+/,
      `${floored.toLocaleString('en-US')}+`
    );
  }

  card(r, i) {
    const stars = STAR.repeat(Math.round(r.rating));
    const date = formatDate(r.created_at);
    /* The first row is in view the moment the track paints, so eager-load it;
       everything past it waits until the carousel is scrolled. */
    const loading = i < 4 ? 'eager' : 'lazy';
    return `<li class="gw-jmr__card">
<div class="gw-jmr__media">
<img class="gw-jmr__image" src="${esc(r.product_pictures_url)}" alt="${esc(r.product_title)}" width="136" height="136" loading="${loading}" decoding="async">
<div class="gw-jmr__meta">
<div class="gw-jmr__meta-top">
<div class="gw-jmr__name-row"><span class="gw-jmr__name">${esc(r.reviewer_name)}</span>${r.verified_buyer ? BADGE : ''}</div>
<div class="gw-jmr__rating">
<div class="gw-jmr__stars" role="img" aria-label="${r.rating} out of 5 stars">${stars}</div>
${date ? `<span class="gw-jmr__date">${esc(date)}</span>` : ''}
</div>
</div>
<a class="gw-jmr__product" href="${esc(r.product_url)}">View ${esc(r.product_title)}</a>
</div>
</div>
<div class="gw-jmr__text">
${r.title ? `<h3 class="gw-jmr__title">${esc(r.title)}</h3>` : ''}
<div class="gw-jmr__body">${sanitizeBody(r.body_html || `<p>${esc(r.body)}</p>`)}</div>
</div>
</li>`;
  }

  render(reviews) {
    this.track.innerHTML = reviews.map((r, i) => this.card(r, i)).join('');
    this.removeAttribute('data-gw-jmr-loading');
    /* The carousel chrome lives in <gw-scroll-carousel> (assets/gw-scroll-carousel.js),
       shared with gw-product-carousel. Cards arrive after connectedCallback, so
       the measurements are retaken here rather than bound locally. */
    const carousel = this.querySelector('gw-scroll-carousel');
    if (carousel && typeof carousel.refresh === 'function') {
      carousel.refresh();
    } else if (carousel) {
      customElements.whenDefined('gw-scroll-carousel').then(() => carousel.refresh());
    }
  }

  /* No data: placeholder in the editor, nothing at all on the live site. */
  fail() {
    const section = this.closest('.gw-jmr') || this;
    if (this.designMode) {
      section.innerHTML =
        '<p class="gw-jmr__placeholder">Judge.me Reviews — no reviews could be loaded. Check the API token and shop domain in this section&rsquo;s settings.</p>';
    } else {
      section.hidden = true;
      section.innerHTML = '';
    }
  }
}

if (!customElements.get('gw-jm-reviews')) {
  customElements.define('gw-jm-reviews', GwJmReviews);
}

if (window.wetheme && window.wetheme.webcomponentRegistry) {
  window.wetheme.webcomponentRegistry.register({
    key: 'gw-judgeme-reviews',
    element: 'gw-jm-reviews',
  });
}
